import { render, staticRenderFns } from "./InvoiceTotals.vue?vue&type=template&id=c2d99fa6&scoped=true&"
import script from "./InvoiceTotals.vue?vue&type=script&lang=ts&"
export * from "./InvoiceTotals.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceTotals.vue?vue&type=style&index=0&id=c2d99fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d99fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
